import React from 'react';

import Apexchart from 'src/components/Apexchart';
import { Dashboard } from 'src/interfaces/models/Dashboard';

type ReasonsLostChartProps = {
  data?: Dashboard['reasonsLost'];
};

const ReasonsLostChart: React.FC<ReasonsLostChartProps> = ({ data }) => {
  return (
    <Apexchart
      type="bar"
      options={{
        title: {
          text: 'Perda',
          align: 'center',
        },
        chart: { id: 'reasons-lost' },
        yaxis: {
          // min: 1,
          // stepSize: 1,
        },
        xaxis: {
          categories: data?.labels || [''],
        },
        dataLabels: {
          dropShadow: {
            enabled: true,
          },
        },
        legend: {
          formatter() {
            return '';
          },
        },
      }}
      series={data?.series || []}
    />
  );
};

export default ReasonsLostChart;
